/**
 * Formats a duration in seconds the way the total-journey-time design shows it: the minutes
 * part is omitted entirely below one minute ("24s"), and from one minute up the seconds are
 * zero-padded ("1m 12s").
 *
 * Kept in its own module (rather than beside the widget) so it stays unit-testable without
 * pulling the whole widget/UI component tree into the test.
 */
export function formatJourneyDuration(totalSeconds: number): string {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = Math.floor(totalSeconds % 60);
  if (minutes === 0) return `${seconds}s`;
  return `${minutes}m ${seconds.toString().padStart(2, '0')}s`;
}
